module.exports = __webpack_public_path__ + "static/media/video5.c3cead9c.mp4";